export enum SpeciesType {
  Canine = 1,
  Feline,
  Equine,
  Bird,
  Porcine,
  Vulpine,
  Lagomorph,
  Reptile,
  Ferret,
  Exotic,
  Small_Animal,
  Other,
  Fish,
  Spiders_Insects,
  Farm_Animal,
  Amphibian,
  Unknown,
}
